var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-text-centered ml-1"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_c('div',{staticClass:"ml-2 cap-first",attrs:{"v-if":_vm.label != null && _vm.label.length > 0}},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }